import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { Answer, Client, globalRegions, PostAnswerBody, Question, User } from 'altru-types';
import { getAnswer, postAnswer } from '@/store/answers/api';
import { Credentials } from '@/store/auth/types';

@Module({ namespaced: true })
export default class AnswersModule extends VuexModule {
  answer: Answer | null = null;

  originalAnswer: Answer | null = null;

  get answerInfo(): Answer | null {
    return this.answer;
  }

  get payloadAnswerInfo(): Answer | null {
    return this.originalAnswer;
  }

  @Mutation
  setAnswerInfo(value: Answer): void {
    this.answer = value;
  }

  @Mutation
  setOriginalAnswer(value: Answer): void {
    this.originalAnswer = value;
  }

  @Action
  async addAnswerInfo(payload: Answer): Promise<void> {
    try {
      this.context.commit('setAnswerInfo', payload);
    } catch (e) {
      return e.response;
    }
  }

  @Action
  async getOriginalAnswer({
    answerId,
    authHeaders,
    region = 'us',
  }: {
    answerId: string;
    authHeaders: Credentials;
    region: globalRegions;
  }): Promise<Answer> {
    try {
      const answer = await getAnswer({ answerId, authHeaders, region });
      this.context.commit('setOriginalAnswer', answer);
      return answer;
    } catch (e) {
      return e.response;
    }
  }

  @Action({ rawError: true })
  async postAnswer(): Promise<Answer> {
    try {
      const questionWorkspace: Client = this.context.rootState.clients.workspace;
      const question: Question = this.context.rootState.questions.question;
      const user: User = this.context.rootState.users.user;

      const postAnswerBody: PostAnswerBody = {
        question_id: question.id,
        user_id: user.id,
        assigner_id: user.id,
        status: 'assigned',
        max_duration: question.max_duration,
        locale: question.locale,
      };
      const headers = this.context.rootState.auth.credentials;
      const region = questionWorkspace.global_region ?? 'us';

      return postAnswer({
        postAnswerBody,
        headers,
        region,
      });
    } catch (e) {
      return e.response;
    }
  }
}
